import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';
export const ShoppingIcon = (props: IconPropsType): JSX.Element => {
  const {fill = '#43494F'} = props;
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13119_26404)'>
        <path
          d='M16.625 8.75V3.5H12.2054C11.9849 1.5365 10.3337 0 8.3125 0C6.29125 0 4.64013 1.5365 4.41963 3.5H0V14C0 15.4473 1.17775 16.625 2.625 16.625H5.25V18.375C5.25 19.8223 6.42775 21 7.875 21H18.375C19.8223 21 21 19.8223 21 18.375V8.75H16.625ZM8.3125 1.75C9.36862 1.75 10.2524 2.5025 10.4554 3.5H6.16963C6.37262 2.5025 7.25637 1.75 8.3125 1.75ZM2.625 14.875C2.14287 14.875 1.75 14.483 1.75 14V5.25H4.375V7H6.125V5.25H10.5V7H12.25V5.25H14.875V8.75H5.25V14.875H2.625ZM19.25 18.375C19.25 18.858 18.8571 19.25 18.375 19.25H7.875C7.39288 19.25 7 18.858 7 18.375V10.5H19.25V18.375ZM9.625 14V12.25H11.375V14C11.375 14.9651 12.1599 15.75 13.125 15.75C14.0901 15.75 14.875 14.9651 14.875 14V12.25H16.625V14C16.625 15.9303 15.0553 17.5 13.125 17.5C11.1947 17.5 9.625 15.9303 9.625 14Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

ShoppingIcon.iconType = ICON_TYPES.SHOPPING;
